<template>
    <div class="card shadow-sm overflow-hidden">
        <div class="card-header d-flex align-items-center py-1 px-2">
            <div class="flex-grow-1">
                <strong>熱點狀態</strong>
            </div>
        </div>
        <div class="card-body p-2">
            <template v-if="isInteractive">
                <button class="btn btn-sm btn-block btn-success"
                        v-bind:class="{ 'btn-loading': isLoading }"
                        v-on:click="approve">
                    👌 批準熱點
                </button>
                <button class="btn btn-sm btn-block btn-danger mb-3"
                        v-bind:class="{ 'btn-loading': isLoading }"
                        v-on:click="reject">
                    ⛔ 拒絕熱點
                </button>
                <p class="text-center text-nowrap mb-0"
                   v-if="reply">
                    <small>先前回覆：</small><strong>{{ reply }}</strong>
                </p>
            </template>
            <template v-else>
                <button class="btn btn-sm btn-block"
                        disabled
                        v-bind:class="{ 'btn-success': isApproved, 'btn-outline-secondary': !isApproved, }">
                    👌 已被批準
                </button>
                <button class="btn btn-sm btn-block"
                        disabled
                        v-bind:class="{ 'btn-danger': !isApproved, 'btn-outline-secondary': isApproved, }">
                    ⛔ 已被拒絕
                </button>
            </template>
        </div>
    </div>
</template>

<script>
const TaskStageMap = new Map(
    [
        ["5ed2f24c5dafc6343ed2aa2d", false],
        ["5ed2f3d352a8f2d15a1f7a67", false],
        ["5ed2f41552a8f2d15a1f7a69", true],
        ["5ed308b127cb2d7684bc3423", true],
        ["5ed309638132e677e36b6e48", true],
        ["5ed30bf79594587e7a8d2178", true],
        ["6000fe508d65ee9ddee9f77f", true],
        ["6000fe658d65ee9ddee9f780", true],
        ["6000fe6c8d65ee9ddee9f781", false],
        ["6000fe738d65ee9ddee9f782", false],
    ]
);
export default {
    name: "TaskApprove",
    props: {
        stage: {
            type: String,
        },
        response: {
            type: Object,
        },
    },
    data () {
        return {
            isLoading: false,
        };
    },
    computed: {
        taskId () {
            return this.$route.params.taskId;
        },
        isApproved () {
            return TaskStageMap.get(this.stage);
        },
        isInteractive () {
            return /*!this.response?.["pending"] &&*/ this.stage === "5ed2f3d352a8f2d15a1f7a67";
        },
        reply () {
            return this.response["pending"] ?
                this.response["pending"] === "approved" ?
                    "👌 已被批準" :
                    "⛔ 已被拒絕" :
                "";
        },
    },
    methods: {
        async approve () {
            console.log(this.taskId);
            this.isLoading = true;
            try {
                await this.$store.dispatch("tasks/approve", this.taskId);
            } catch (e) {
                console.error(e);
            }
            this.isLoading = false;
        },
        async reject () {
            this.isLoading = true;
            try {
                await this.$store.dispatch("tasks/reject", this.taskId);
            } catch (e) {
                console.error(e);
            }
            this.isLoading = false;
        },
    },
}
</script>

<style lang="scss" scoped>
.card-header {
    font-size: 0.9rem;
}
</style>
